// extracted by mini-css-extract-plugin
export default {"roll":"RollPulse_roll__sJNN7","rollPulse":"RollPulse_rollPulse__7yTWp","scale":"RollPulse_scale__C90fx","blank":"RollPulse_blank__-VP-Z","loading":"RollPulse_loading__bGCLa"};